export interface FeatureSwitches {
  sinaGestionar: boolean;
  notificaciones: boolean;
  passkey: boolean;
  homeKpis: boolean;
  climaOrganizacional: boolean;
}

export const defaultFeatureSwitches: FeatureSwitches = {
  sinaGestionar: false,
  notificaciones: false,
  passkey: false,
  homeKpis: false,
  climaOrganizacional: false,
};

export const isDevCargo = (cargo?: string | null): boolean => {
  if (!cargo) return false;
  const cargoNorm = cargo.toLowerCase();
  return cargoNorm.includes("desarrollador")
    || cargoNorm.includes("gerente de tecnologias de la informacion")
    || cargoNorm.includes("coordinador de base de datos y procesos");
};
